export default __webpack_public_path__ + "static/media/img_04.0c05f6f1.jpg";